import type { TagProps } from "./tag.types";
import { tagStyles } from "./tag.styles";

export function Tag(props: TagProps) {
  const { children, color = "yellow", size = "xs", className } = props;

  const classes = tagStyles({
    color,
    size,
    className,
  });

  return <div className={classes}>{children}</div>;
}

Tag.displayName = "Tag";
